import clsx from 'clsx';

//hooks
import useUser from '@/hooks/swr/useUser';

//types
import type { AlbumCardMedia, AlbumCriteria, AlbumTypes } from '@/lib/albums/types';

import type { AlbumAnalyticsType } from '@/components/base/Card';
//components
import Card from '@/components/base/Card';
import AlbumCardMediaGrid from '@/components/pages/albums/AlbumCardMediaGrid';

type AlbumCardType = {
    medias: AlbumCardMedia[];
    countMedias: number;
    title: string;
    type: AlbumTypes;
    analytics: AlbumAnalyticsType;
    criteria: AlbumCriteria;
    className?: string;
    onClick: () => void;
};

const AlbumCard = ({
    medias,
    countMedias,
    title,
    type,
    analytics,
    className = '',
    criteria,
    onClick
}: AlbumCardType) => {
    const { user } = useUser({
        revalidateOnMount: false,
        revalidateOnFocus: false,
        revalidateOnReconnect: false
    });

    return (
        <div
            className={clsx('h-full w-full', className)}
            role="button"
            data-testid="album-card"
            aria-hidden={true}
            onClick={onClick}>
            <Card>
                <Card.Header className="relative">
                    <AlbumCardMediaGrid medias={medias} type={type} criteria={criteria} />
                </Card.Header>
                <div className="flex flex-1 flex-col justify-between space-y-m">
                    <Card.Content title={title} countMedias={countMedias} criteria={criteria} />
                    <Card.Footer
                        analytics={analytics}
                        userNumbersFormat={user?.settings?.numbers_format}
                    />
                </div>
            </Card>
        </div>
    );
};

export default AlbumCard;
